import { useSelectedAudioVolumeUpdatesHandler } from '../../hooks'

import { Text } from 'common-components'
import { RangeSlider } from 'common-components'
import VolumeIcon from 'assets/svgr-icons/Volume.svg'
import { memo } from 'react'

import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

const VolumeSlider = () => {
  const { volume, onChangeVolume } = useSelectedAudioVolumeUpdatesHandler()

  return (
    <Styled.VolumeSliderContainer>
      <Text type="h2">{translate(T.VOLUME)}</Text>
      <Styled.VolumeSliderWrapper>
        <VolumeIcon />

        <RangeSlider
          onChange={event => {
            const value = parseFloat(event.target.value)
            onChangeVolume(value)
          }}
          isFullWidth
          value={volume}
        />

        <Styled.VolumePercent type="h4" color="secondaryDark">
          {volume}%
        </Styled.VolumePercent>
      </Styled.VolumeSliderWrapper>
    </Styled.VolumeSliderContainer>
  )
}

export default memo(VolumeSlider)
